
/**
 * Status einer Verleihbuchung.
 */
export enum RentalBookingStatus {

    /**
     * Buchungsanfrage vom Kunden erhalten.
     */
    requested = "requested",

    /**
     * Buchungsanfrage von der Verwaltungs bestätigt.
     */
    confirmed = "confirmed",

    /**
     * Verleihgegenstände abgeholt.
     */
    rentalCollected = "rentalCollected",

    /**
     * Verleihgegenstände zurückgebracht. Zur Rechnungsstellung müssen noch Informationen von der Verwaltung eingetragen werden.
     */
    rentalReturned = "rentalReturned",

    /**
     * Rechnung kann gestellt werden.
     */
    readyForPayment = "readyForPayment",

    /**
     * Rechnung wurde exportiert.
     */
    paymentExported = "paymentExported",

    /**
     * Buchung wurde als bezahlt markiert.
     */
    paymentReceived = "paymentReceived",

    /**
     * Verleih wurde von Kunde storniert. Mitarbeiter:in muss Stornierung bestaetigen.
     */
    cancellationPending = "cancellationPending",

    /**
     * Buchung wurde storniert. Rechnung fuer Stornierungsgebuehr kann gestellt werden.
     */
    canceled = "canceled",

    /**
     * Buchung wurde storniert und Stornierungsgebühr wurde exportiert.
     */
    cancellationFeeExported = "cancellationFeeExported",

    /**
     * Buchung wurde storniert und die Gebühr als bezahlt markiert.
     */
    cancellationFeeReceived = "cancellationFeeReceived",

    /**
     * Mietgegenstand ist für internen Gebrauch reserviert.
     */
    internalReservation = "internalReservation"
}

export const RentalBookingStatusNames = {
    requested: "Angefragt",
    confirmed: "Bestätigt",
    rentalCollected: "Produkt abgeholt",
    rentalReturned: "Produkt zurückgebracht",
    readyForPayment: "Bereit für Bezahlung",
    paymentExported: "Rechnung wurde exportiert",
    paymentReceived: "Als bezahlt markiert",
    cancellationPending: "Storniert, Bestätigung benötigt",
    canceled: "Storniert, Gebühr-Export ausstehend",
    cancellationFeeExported: "Storniert, Gebühr wurde exportiert",
    cancellationFeeReceived: "Storniert, als bezahlt markiert",
    internalReservation: "Interne Buchung"
};